import { pList, rUstBilgi, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_FAALIYETALANIUSTBILGI,
    new Api.Bilgi.FaaliyetAlani().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rUstBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rUstBilgi> =>
  ActionFunctions.action_async_complete_api<rUstBilgi>(
    ActionSubTypes.API_FAALIYETALANIUSTBILGI,
    data?.Value,
    error
  );
